import { SET_BINOMIAL_ALPHA } from './types';

export const setBinomialAlpha = binomialAlpha => ({ type: SET_BINOMIAL_ALPHA, binomialAlpha });
